import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "catalog-arrow",
  "use": "catalog-arrow-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"catalog-arrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.84611 5.99998L0.77002 1.55841L1.37014 0.872559L6.83814 5.65706L7.23005 5.99998L6.83814 6.34291L1.37014 11.1274L0.77002 10.4416L5.84611 5.99998Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol